import { SignUp } from '@clerk/react';
import { colors } from '@yorukiri/ui/tokens';

export function SignUpRoute() {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: colors.bg,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        backgroundImage:
          'radial-gradient(ellipse at 50% 0%, rgba(59, 42, 255, 0.05), transparent 50%)',
      }}
    >
      <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" fallbackRedirectUrl="/" />
    </div>
  );
}
